/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconError404Off = createReactComponent("error-404-off", "IconError404Off", [
  ["path", { d: "M3 7v4a1 1 0 0 0 1 1h3", key: "svg-0" }],
  ["path", { d: "M7 7v10", key: "svg-1" }],
  [
    "path",
    {
      d: "M10 10v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2m0 -4v-2a1 1 0 0 0 -1 -1h-2",
      key: "svg-2"
    }
  ],
  ["path", { d: "M17 7v4a1 1 0 0 0 1 1h3", key: "svg-3" }],
  ["path", { d: "M21 7v10", key: "svg-4" }],
  ["path", { d: "M3 3l18 18", key: "svg-5" }]
]);

export { IconError404Off as default };
//# sourceMappingURL=IconError404Off.js.map
